module.exports = __webpack_public_path__ + "img/foundationStictching2.354924a5.jpg";